import { create as createStore } from "zustand"
import { persist } from "zustand/middleware"

interface PreferredWorkspaceState {
  preferredWorkspaceId: string | null
  setPreferredWorkspaceId: (id: string | null) => void
}

export const usePreferredWorkspaceStore = createStore(
  persist<PreferredWorkspaceState>(
    (set) => ({
      preferredWorkspaceId: null,
      setPreferredWorkspaceId: (id) => {
        set({ preferredWorkspaceId: id })
      },
    }),
    {
      name: "preferred-workspace-state",
    }
  )
)
